import React from "react";
import {
  businessMatchingRootPath,
  newContactPath,
  newPostPath,
  postsPath,
  studyGroupsPath,
  userPath,
} from "../../../../../../routes";
import { SharedCurrentUser } from "../../../lib/types";

import { Box, MenuDivider, MenuList, Text } from "@chakra-ui/react";
import SmsIcon from "../../icons/SmsIcon";
import Button from "../../ui/Button";
import { CustomMenuItem } from "./CustomMenuItem";
import { ArchitectRegistrationPrompt } from "./ArchitectRegistrationPrompt";
import { ArchitectApplicationRevisionPrompt } from "./ArchitectApplicationRevisionPrompt";
import { ArchitectApplicationPendingPrompt } from "./ArchitectApplicationPendingPrompt";

export const ProfileMenuList = ({
  currentUser,
  logout,
}: {
  currentUser: NonNullable<SharedCurrentUser>;
  logout: () => void;
}) => {
  return (
    <MenuList pt={0} maxW="xs" overflow="hidden" borderColor="#DFE5EA">
      {currentUser.is_unapproved &&
        (currentUser.latest_personal_info_application_rejected ? (
          <ArchitectApplicationRevisionPrompt />
        ) : currentUser.personal_info_applicationing ? (
          <ArchitectApplicationPendingPrompt />
        ) : (
          <ArchitectRegistrationPrompt />
        ))}
      <Box px={5} pt={5} pb={2}>
        <Text fontSize="sm" fontWeight="bold">
          プロフィール
        </Text>
      </Box>
      {currentUser.header_profile_menu_items.map(({ label, href }, index) => (
        <CustomMenuItem href={href} key={index}>
          {label}
        </CustomMenuItem>
      ))}
      <MenuDivider />
      <Box px={5} pt={4} pb={2}>
        <Text fontSize="sm" fontWeight="bold">
          コンテンツ
        </Text>
      </Box>
      <CustomMenuItem href={postsPath()}>Q&A</CustomMenuItem>
      {currentUser.is_all_public_feature_accessible && (
        <CustomMenuItem href={userPath(currentUser.code, { "qa-tab": "bookmarked" })}>ブックマーク</CustomMenuItem>
      )}
      <CustomMenuItem href={studyGroupsPath()}>勉強会</CustomMenuItem>
      {currentUser.is_show_business_matching_link && (
        <CustomMenuItem href={businessMatchingRootPath()} isExternal>
          協力事務所を探す（β版）
        </CustomMenuItem>
      )}
      {currentUser.is_all_public_feature_accessible && (
        <Box bgColor="#EDF5F3" px={5} py={4}>
          <Text fontSize="xs" textAlign="center">
            Q&Aで気軽に質問・コメントしてみましょう
          </Text>
          <Button w="full" mt={3} leftIcon={<SmsIcon />} iconSpacing={1} as="a" href={newPostPath()}>
            質問を投稿
          </Button>
        </Box>
      )}
      {!currentUser.is_all_public_feature_accessible && <MenuDivider />}
      <CustomMenuItem href={newContactPath()} isExternal>
        お問い合わせ
      </CustomMenuItem>
      <CustomMenuItem onClick={logout}>ログアウト</CustomMenuItem>
    </MenuList>
  );
};
